import React, { useState } from "react";
import {
  Form,
  Button,
  Typography,
  Select,
  Input,
  Row,
  Col,
  Popconfirm,
  Divider,
  InputNumber,
  message,
  DatePicker,
  Statistic,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import Dropzone from "react-dropzone-uploader";
import "react-dropzone-uploader/dist/styles.css";

//Importaciones para el uso de Redux
import { useDispatch, useSelector } from "react-redux";
import { updateRolEnviromentAction } from "../../../actions/rolEnviromentActions";

//Styles
import "./SalidasAnm.scss";

// componentes
import FRM from "../../../utils/FrmService";
import { reloadData } from "../../../utils/ReloadEnv";
import { showNotification } from "../../../utils/ShowNotification";
import curStyle from "../../../css/GlobalCmp.module.css";
import { URL_FILES } from "../../../constants";
import CST from "../../../utils/CustomSettings";

export default function CjbPagosLcl(props) {
  const {
    currentUser,
    closeModal,
    setStateCbr,
    currentSetup,
    myNumber,
    listCxc,
  } = props;
  const [loadingButton, setLoadingButton] = useState(false);
  const [valorBnc, setValorBnc] = useState(0);
  const [idBnc, setIdBnc] = useState(0);
  const [idProveedor, setIdProveedor] = useState(0);
  const [saldoClt, setSaldoClt] = useState(0);
  const [nota, setNota] = useState("");
  const [nameAdjunto, setNameAdjunto] = useState("");
  const [fechaEntr, setFechaEntr] = useState(null);

  const { Option } = Select;
  const [form] = Form.useForm();

  //Listado de conceptos
  const listaCnc = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.conceptos_gto
  );

  const cuentasLcl = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.cuentas_lcl
  );

  //Listado de proveedores
  const suppliersList = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.clientes
  );

  //Ejecutar dispatch tras el logueo
  const dispatch = useDispatch();
  const updateEnviroment = (state) =>
    dispatch(updateRolEnviromentAction(state));

  const { Title } = Typography;
  const { TextArea } = Input;

  //Cambio de fecha
  function onChangeFecha(date, dateString) {
    setFechaEntr(dateString);
  }
  //Se actualiza el nombre
  const updateProveedor = async (value) => {
    setIdProveedor(value);
    getSaldoClt(listCxc, value);
  };

  //Se actualiza cuenta de banco
  const updateBnc = async (value) => {
    setIdBnc(value);
    //setValorBnc(0);
  };

  const onChangeBnc = (value) => {
    if (Number.parseFloat(value) >= 0) {
      setValorBnc(value);
    } else {
      message.error("VALOR INCORRECTO!", 1);
      return false;
    }
  };

  const onChangeNota = (e) => {
    const notaE = e.target.value;
    setNota(notaE.toUpperCase());
  };

  //Funcion para traer el % de conversion del alimento
  const getSaldoClt = async (listCxc, idClt) => {
    setSaldoClt(0);
    message.info("ACTUALIZANDO SALDO", 1);
    listCxc.forEach((arrayValue) => {
      if (Number.parseInt(arrayValue.trc_id) === Number.parseInt(idClt)) {
        setSaldoClt(Number.parseFloat(arrayValue.saldo));
      }
    });
  };

  //GESTION DE CARGAR DE ARCHIVOS PDF
  // specify upload params and url for your files
  const getUploadParams = ({ file, meta }) => {
    const body = new FormData();
    body.append("file", file);
    const headers = new Headers();
    headers.append("accept", "application/json");
    return { url: "https://api.aal-erp.com/frm/api/712", body, headers };
  };

  // called every time a file's `status` changes
  //const handleChangeStatus = ({ meta, file }, status) => { console.log(status, meta, file) }
  const handleChangeStatus = ({ meta, remove }, status) => {
    console.log(meta);
    if (status === "headers_received") {
      setNameAdjunto(meta.name);
      message.success("CARGA DE ADJUNTO EXITOSA", 1);
      //alert(`${meta.name} uploaded!`);
      remove();
    } else if (status === "aborted") {
      message.error("CARGA DE ADJUNTO FALLIDA", 2);
    }
  };

  const openAdjunto = (pdf_file) => {
    //Url para visaulizacion del PDF Temporal
    const url_temp = URL_FILES + currentUser.dominio + "/temporal/" + pdf_file;
    window.open(`${url_temp}`);
  };
  //FIN GESTION DE CARGA DE ARCHIVOS

  /////////////////////////////////
  // ENVIO A WEBSERVICES
  const registrarPago = async () => {
    if (Number.parseFloat(valorBnc) === 0) {
      showNotification(
        "topRight",
        2,
        "REGISTRAR PAGO DE GASTO",
        "EL MONTO NO CORRESPONDE AL VALOR DEL GASTO"
      );
    } else {
      if (
        Number.parseInt(valorBnc) === 0 ||
        Number.parseInt(idProveedor) === 0 ||
        Number.parseInt(idBnc) === 0
      ) {
        showNotification(
          "topRight",
          2,
          "REGISTRAR PAGO DE GASTOS",
          "DATOS INCOMPLETOS PARA EL REGISTRO"
        );
      } else {
        setLoadingButton(true);
        let record = {
          tipoMov: 3,
          usr_id: currentUser.id,
          rcl_fecha: fechaEntr,
          trc_id: idProveedor,
          efe_id: 0,
          cue_id: idBnc,
          rcl_importe: Number.parseFloat(valorBnc),
          rcl_efectivo: 0,
          rcl_transfer: Number.parseFloat(valorBnc),
          rcl_transfer_fr: 0,
          rcl_nota: nota,
          rcl_adjunto: nameAdjunto.length === 0 ? "NA" : nameAdjunto,
          rcl_moneda: 1,
          rcl_cambio: currentSetup.sup_cambio,
        };

        var val_gasto = await FRM.sendFactura(currentUser, record);
        if (val_gasto.type && Number.parseInt(val_gasto.type) > 0) {
          updateEnviroment(val_gasto.datos.rol_entorno);
          setStateCbr(Math.random());
          showNotification(
            "topRight",
            4,
            "CARGAR COBROS",
            "REGISTRO DE COBRO EXITOSO"
          );
        } else {
          showNotification("topRight", 2, "CARGAR COBROS", val_gasto.message);
        }
        setLoadingButton(false);
        closeModal();
      }
    }
  };

  return (
    <div className="upload-panel">
      <Divider
        style={{
          marginTop: 15,
          paddingTop: 10,
          marginBottom: 20,
          fontSize: 20,
        }}
      >
        DATOS GENERALES COBRO A CLIENTES
      </Divider>
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item label="Fecha de Pago">
              <DatePicker onChange={onChangeFecha} style={{ width: "100%" }} />
            </Form.Item>
          </Col>
          <Col span={13}>
            <Form.Item label="Cliente Deudor">
              <Select
                showSearch
                showArrow
                style={{ width: "100%" }}
                defaultValue={
                  idProveedor > 0 ? idProveedor : "SELECCIONE CLIENTE"
                }
                placeholder="CLIENTE"
                onChange={updateProveedor}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {suppliersList.map((proveedor) => (
                  <Option key={proveedor.trc_id} value={proveedor.trc_id}>
                    {proveedor.trc_nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Statistic
              title="SALDO ACTUAL"
              value={myNumber(1, saldoClt)}
              valueStyle={{
                fontSize: 20,
                color: saldoClt > 0 ? CST.redBdy : CST.greenBdy,
                fontWeight: "bold",
                textAlign: "right",
              }}
            />
          </Col>
        </Row>
        <Divider style={{ marginTop: 5, paddingTop: 5, marginBottom: 5 }} />
        <Row gutter={16}>
          <Col span={18}>
            <Form.Item label="Cuenta Receptora de los Fondos">
              <Select
                showSearch
                showArrow
                style={{ width: "100%" }}
                defaultValue={idBnc > 0 ? idBnc : "ELIJA CUENTA"}
                placeholder="CONCEPTO"
                onChange={updateBnc}
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {cuentasLcl.map((bancos) => (
                  <Option key={bancos.cue_id} value={bancos.cue_id}>
                    {bancos.cue_nombre}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="Monto Recibido">
              <InputNumber
                style={{ width: "100%", textAlign: "right" }}
                formatter={(value) =>
                  `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                min={0}
                defaultValue={valorBnc}
                value={valorBnc}
                onChange={onChangeBnc}
                placeholder="Deposito"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col span={24}>
            <TextArea
              rows={2}
              value={nota}
              placeholder={"Observaciones"}
              onChange={onChangeNota}
              allowClear
            />
          </Col>
        </Row>
      </Form>
      <Divider style={{ marginTop: 15, paddingTop: 10, marginBottom: 5 }}>
        {"Comprobante de respaldo"}
      </Divider>
      {nameAdjunto.length > 0 ? (
        <Button
          type="link"
          size="large"
          onClick={() => openAdjunto(nameAdjunto)}
        >
          {nameAdjunto}
        </Button>
      ) : null}
      <div
        style={{
          textAlign: "center",
          marginTop: 20,
          border: 0,
        }}
      >
        <Dropzone
          getUploadParams={getUploadParams}
          onChangeStatus={handleChangeStatus}
          autoUpload={true}
          maxFiles={1}
          multiple={false}
          canCancel={false}
          accept=".pdf"
          inputContent={"Arrastre o seleccione el PDF a adjuntar"}
          inputWithFilesContent={"Agregar Archivos"}
          submitButtonContent={"Subir Archivos"}
        />
      </div>
      <Divider style={{ marginTop: 5, paddingTop: 5, marginBottom: 5 }} />
      <div style={{ display: "flex", alignContent: "left", marginTop: 5 }}>
        <Popconfirm
          placement="top"
          title="CONFIRMAR EL MOVIMIENTO?"
          onConfirm={() => registrarPago()}
          okText="Si"
          cancelText="No"
        >
          <Button
            type="primary"
            className={curStyle.btnDark}
            shape="round"
            block
            loading={loadingButton}
          >
            <UploadOutlined /> REGISTRAR EL RECIBO DE PAGO
          </Button>
        </Popconfirm>
      </div>
    </div>
  );
}
